import blog1 from "../../assets/images/blog/blog-01.jpg";
import blog2 from "../../assets/images/blog/blog-02.jpg";
import blog3 from "../../assets/images/blog/blog-03.jpg";
import blog4 from "../../assets/images/blog/blog-04.jpg";

const BlogContent = [
  {
    images: blog1,
    title: "El E-BOOK con los secretos del Marketing",
    category: "Descargalo YA!",
  },
  // {
  //   images: blog2,
  //   title: "Cómo Mejorar el ROI en tus Anuncios Digitales",
  //   category: "Analítica",
  // },
  // {
  //   images: blog3,
  //   title: "Tendencias en Marketing de Contenidos para 2025",
  //   category: "Contenido",
  // },
  // {
  //   images: blog4,
  //   title: "La Psicología del Color en el Branding",
  //   category: "Diseño",
  // },
  // {
  //   images: blog1,
  //   title: "Segmentación Efectiva para Alcanzar Nuevos Mercados",
  //   category: "Estrategia",
  // },
  // {
  //   images: blog2,
  //   title: "Automatización de Marketing: Herramientas Clave",
  //   category: "Tecnología",
  // },
];


export default BlogContent;